import React, { Component } from "react";
import moment from "moment";
import { I8N } from "@eres/core";
import { getInputStyle } from "./Form/TextInputField";

interface Props {
	id: string;
	label?: string;
	required?: boolean;
	value?: Date;
	opts?: object;
	onDateSet?: ( value: Date ) => void;
	inputClassName?: string;
	containerClassName?: string;
	error?: string;
	placeholder?: string;
	errorInputClass?: string;
	disable?: boolean;
	hideRequiredStar?: boolean;
}

const ArDefaults = {
	closeText: "إغلاق",
	prevText: "&#x3C;السابق",
	nextText: "التالي&#x3E;",
	currentText: "اليوم",
	monthNames: [ "يناير", "فبراير", "مارس", "ابريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر" ],
	monthNamesShort: [ "يناير", "فبراير", "مارس", "ابريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر" ],
	dayNames: [ "الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت" ],
	dayNamesShort: [ "الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت" ],
	dayNamesMin: [ "ح", "ن", "ث", "ر", "خ", "ج", "س" ],
	weekHeader: "أسبوع",
	dateFormat: "dd/mm/yy",
	firstDay: 6,
	isRTL: true,
	showMonthAfterYear: false,
	yearSuffix: ""
};

class JqDatePicker extends Component<Props> {
	static defaultProps: Partial<Props> = {
		containerClassName: "form-group",
        inputClassName: "form-control ltr-text-field calendar-icon",
		errorInputClass: "form-input-error is-invalid",
		opts: {
			changeMonth: true,
			changeYear: true,
			dateFormat: "dd-mm-yy",
		}
	};
	onSelect = ( v1: any, v2: any ) => {
		let d = window.$( "#" + this.props.id ).datepicker( "getDate" );
		let x = moment( d ).startOf( "day" );
		if ( this.props.onDateSet ) this.props.onDateSet( x.toDate() );

	};

	componentWillReceiveProps( nextProps: Readonly<Props>, nextContext: any ): void {
		if ( this.props.value !== nextProps.value ) {
			window.$( "#" + this.props.id ).datepicker( "setDate", nextProps.value );
		}
	}

	componentDidMount(): void {
		if ( I8N.locale() === "ar" ) {
			window.$.datepicker.setDefaults( ArDefaults );
		}
		const props = this.props;
		window.$( "#" + props.id ).datepicker( {
			...props.opts,
			onSelect: this.onSelect,
		} );
		if ( props.value ) {
			window.$( "#" + props.id ).datepicker( "setDate", props.value );
		}
		if ( this.props.disable ) {
			window.$( "#" + props.id ).datepicker( "disable", props.disable );
		}
	}

	render() {
		const {
			id,
			label,
			required,
			placeholder,
			inputClassName,
			errorInputClass,
			error,
			disable,
			value,
			hideRequiredStar
		} = this.props;
		let className = inputClassName + ( error ? ` ${ errorInputClass }` : "" );

		let inputStyle = getInputStyle( false, required, value ? value + "" : "", error );
		return (
			<React.Fragment>
				<div className={ this.props.containerClassName }>
					<label htmlFor={ id }><span>{ label }</span>
						{ required && !hideRequiredStar && <span className="asterisk">*</span> }
					</label>
					<input
						type="text" className={ className + inputStyle } name={ id } id={ id } disabled={ disable }
						autoComplete={ "off" }
						placeholder={ placeholder ? placeholder : label } required={ required }/>
					{ error && <div className="invalid-feedback invalid-feedback-x">
						{ error }
					</div> }
				</div>
			</React.Fragment>
		);
	}
}

export default JqDatePicker;
